<template>
	<div class="duonenghububox22">
		<!-- <divBox1 :title="'多能互补'"></divBox1> -->
    <title1 title="能源调度" subTitle="Multi Energy Complementarity" />
		<div class="line-box-duonenghubu"></div>
		<div class="main-box-duonenghubu">
			<div class="img-rotate-box">
				<img class="infogif" src="~@/assets/images/exposition/duonenghubuapng.png" alt="">
				<img class="info" src="~@/assets/images/exposition/duogongnenghubu.png" alt="">
				
				<div class="infobox infobox1 ">
					<div class="top text-left">
						<span class="DS-Digital-Bold">
							{{filterNumber(datainfos.charge_discharge_elect)}} 
						</span>
						kWh
					</div>
					<div class="bottom">光伏发电</div>
				</div>
				<div class="infobox infobox2">
					<div class="top text-left">
						<span class="DS-Digital-Bold">
							{{filterNumber(datainfos.charge_elect)}} 
						</span>
						kWh
					</div>
					<div class="bottom">充电桩</div>
				</div>
				<div class="infobox infobox3">
					<div class="top text-left">
						<span class="DS-Digital-Bold">
							{{filterNumber(datainfos.grid_transmission)}} 
						</span>
						kWh
					</div>
					<div class="bottom">电网输电</div>
				</div>
				<div class="infobox infobox4">
					<div class="top text-left">
						<span class="DS-Digital-Bold">
							{{filterNumber(datainfos.exchange_elect)}} 
						</span>
						kWh
					</div>
					<div class="bottom">换电站</div>
				</div>
				<div class="infobox infobox5">
					<div class="top text-left">
						<span class="DS-Digital-Bold">
							{{filterNumber(datainfos.store_discharge_elect)}} 
						</span>
						kWh
					</div>
					<div class="bottom">储能放电</div>
				</div>
				<div class="infobox infobox6">
					<div class="top text-left">
						<span class="DS-Digital-Bold">
							{{filterNumber(datainfos.store_recharge_elect)}} 
						</span>
						kWh
					</div>
					<div class="bottom">储能充电</div>
				</div>
				<div class="name">
					多能  <br>
					互补
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		dataInterface
	} from '@/api/dataInterfaceApi';
	import divBox1 from '@/views/mobile/components/divBox1'
  import title1 from '@/views/exposition/components/title2'
	export default{
		components: {
			divBox1,
      title1
		},
		data() {
			return{
				datainfos:{
					
				}
			}	
		},
    destroyed() {
				// this.$bus.$off('onfangdiangonglv')
			},
		mounted() {
      this.$bus.$on('onfangdiangonglv', ()=>{
					this.getduonenghubu()
				})
			this.getduonenghubu()
		},
		methods: {
			filterNumber(value) {
				console.log('9999999999999999999999999999999999999')
				console.log(value)
				if(value) {
					return Number(value).toFixed(0)
				} else {
					return '-'
				}
			},
			//获取24小时电次数分布
			getduonenghubu() {
        const now = new Date();
          const year = now.getFullYear();
          const month = (now.getMonth() + 1).toString().padStart(2, "0");
          const day = now.getDate().toString().padStart(2, "0");
          const timer = `${year}-${month}-${day}`
				let params = {
					"enCode": "snec-right-duonenghubu",
          "@dim_date": localStorage.getItem("changeDataNuber") || timer,
					"@harbour_id": localStorage.getItem("harbour_id") || '76df7579ccc24d2693f6488c38a3a0b0'
				}
				dataInterface.dataFaceApi(params).then((res) => {
					console.log(res, '00000000')
					if (res) {
						this.datainfos = res[0] || {}
					}
				}).catch((err) => {
					console.log(err);
				});
			}
		}
	}
</script>

<style lang="scss" scope>
	@import "@/assets/scss/comm.scss";
	.duonenghububox22{
		padding-top: 72px;
		.line-box-duonenghubu{
			height: 42px;
		}
		.main-box-duonenghubu{
			padding: 20px;
			height: 465px;
			position: relative;
			.infogif{
				width: 490px;
				height: 490px;
				transform: translate3d(70px, 50px, 0);
			}
			img{
				width: 450px;
				height: 390px;
			}
			.info{
				width: 750px;
				height: 480px;
				position: absolute;
				left: -40px;
				top: 40px;
			}
			.infobox{
				text-align: center;
				position: absolute;
				width: 140px;
				.top{
					width: 240px;
					height: 70px;
					line-height: 25px;
					font-size: 28px;
					color: #00FDF4;
				}
				.bottom{
					height: 70px;
					line-height: 130px;
				}
			}
			.text-left{
				.DS-Digital-Bold{
					font-size: 34px;
				}
				text-align: left;
				margin-left: -10px;
			}
			.text-right{
				text-align: right;
			}
			.name{
				position: absolute;
				left: 300px;
				top: 263px;
				font-size: 32px;
				font-weight: 600;
				@include ffamily-HT;
			}
			.infobox1{
				left: 90px;
				top: 23px;
			}
			.infobox2{
				right: 56px;
				top: 23px;
			}
			.infobox3{
				left: 12px;
				top: 186px;
			}
			.infobox4{
				right: 5px;
				top: 186px;
			}
			.infobox5{
				left: 84px;
				top: 348px;
			}
			.infobox6{
				right: 59px;
				top: 348px;
			}
			@keyframes rotate {
			    0%{-webkit-transform:rotate(0deg);}
			    25%{-webkit-transform:rotate(90deg);}
			    50%{-webkit-transform:rotate(180deg);}
			    75%{-webkit-transform:rotate(270deg);}
			    100%{-webkit-transform:rotate(360deg);}
			}
			// .img-rotate-box{
			// 	animation: rotate 3s linear infinite;
			// }
		}
	}
	
</style>